export default "__VITE_ASSET__DWr1X22x__"